const removeDuplicates = (array) => {
  return array.filter(element => array.indexOf(element) !== -1);
};

export default removeDuplicates;
